import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash/get';
import * as nextPreviousActions from '../../../store/actions/nextPrevious';
import * as utils from '../../../store/utils';
import { listingPropTypes } from '../../../utils/commonPropTypes';
import * as storage from '../../../utils/storage';

class NextPreviousDataProvider extends Component {
  locateNextPreviousData = (currentUrl) => {
    let nextPreviousSessionData = storage.getSessionItem('nextPreviousData');
    let nextPreviousLocalData = storage.getItem('nextPreviousData');

    if (nextPreviousSessionData) {
      nextPreviousSessionData = JSON.parse(nextPreviousSessionData);
    }

    if (nextPreviousLocalData) {
      nextPreviousLocalData = JSON.parse(nextPreviousLocalData);
    }

    if (nextPreviousSessionData && nextPreviousSessionData.urls.includes(currentUrl)) {
      if (nextPreviousLocalData) {
        nextPreviousSessionData.searchUrl = nextPreviousLocalData.searchUrl;
      }
      return nextPreviousSessionData;
    }

    if (nextPreviousLocalData && nextPreviousLocalData.urls.includes(currentUrl)) {
      storage.setSessionItem('nextPreviousData', JSON.stringify(nextPreviousLocalData));
      return nextPreviousLocalData;
    }

    return null;
  }

  updateNextPreviousLinks = async (lowIndex, highIndexOffset) => {
    const navLinks = {};
    const currentUrl = get(this.props, 'location.pathname', '');
    const nextPreviousData = this.locateNextPreviousData(currentUrl);
    if (nextPreviousData) {
      navLinks.searchUrl = nextPreviousData.searchUrl;
      await nextPreviousActions.checkGetNextUrls(nextPreviousData, lowIndex, highIndexOffset, currentUrl);
      const currentIndex = nextPreviousData.urls.indexOf(currentUrl);
      this.updateNavLinks(currentIndex, navLinks, nextPreviousData);
    }
  }


  updateNavLinks = (currentIndex, navLinks, nextPreviousData) => {
    if (currentIndex > 0) {
      navLinks.previous = nextPreviousData.urls[currentIndex - 1];
    }
    const next = nextPreviousData.urls[currentIndex + 1];
    if (next) {
      navLinks.next = next;
    }
    this.props.setNextPrevious(navLinks);
  };


  componentDidMount() {
    if (!utils.isServer()) {
      this.updateNextPreviousLinks(0, 1);
    }
  }

  componentDidUpdate() {
    const url = get(this.props, 'location.pathname', '');
    if (!utils.isServer()) {
      if (!this.url) {
        this.url = url;
        this.updateNextPreviousLinks(1, 2);
        return;
      }
      if (url !== this.url) {
        this.url = url;
        this.updateNextPreviousLinks(1, 2);
      }
    }
  }

  render() {
    return null;
  }
}

NextPreviousDataProvider.propTypes = {
  listing: listingPropTypes,
  setNextPrevious: PropTypes.func
};

export default connect(
  null,
  (dispatch) => bindActionCreators({
    setNextPrevious: nextPreviousActions.setNextPrevious
  }, dispatch)
)(NextPreviousDataProvider);
